import { fetchQuery } from "relay-runtime";
import environment from "environments/environment";
import getPropertiesQuery from "./queries/getProperties";




const loadProperties = (orgId) => {
  let variables = { orgId };
  return fetchQuery(environment, getPropertiesQuery, variables).then(res => {
    if (res.authorizedSuborgs) return res.authorizedSuborgs;
    return []
  })
    .catch(err => {
      return { errors: [{ message: err.toString() }] };
    });
}


export {
  loadProperties,
};